// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { getWarehouses, WarehousesApiParameter, WarehousesModel } from "@steiner/App/Services/CheckoutWarehouse";

type HandlerType = ApiHandler<WarehousesApiParameter & HasOnSuccess<WarehousesModel>, WarehousesModel>;

export const GetWarehouses: HandlerType = async props => {
    try {
        props.apiResult = await getWarehouses({});
    } catch (error) {
        return false;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [GetWarehouses, ExecuteOnSuccessCallback];

const loadWarehouses = createHandlerChainRunner(chain, "LoadWarehouses");
export default loadWarehouses;
